module.exports = __webpack_public_path__ + "img/a5.fa767446.png";